import { render, staticRenderFns } from "./CreateInvoiceCs.vue?vue&type=template&id=2cbf8172&scoped=true&"
import script from "./CreateInvoiceCs.vue?vue&type=script&lang=js&"
export * from "./CreateInvoiceCs.vue?vue&type=script&lang=js&"
import style0 from "./CreateInvoiceCs.vue?vue&type=style&index=0&id=2cbf8172&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbf8172",
  null
  
)

export default component.exports